import { createContext, type PropsWithChildren } from "react";
import useApplicationTableResource from "./useApplicationTableResource";

export const ApplicationTableResourceContext = createContext({} as ReturnType<typeof useApplicationTableResource>);

const ApplicationTableResourceProvider = ({ children }: PropsWithChildren) => (
    <ApplicationTableResourceContext.Provider
        value={useApplicationTableResource()}
    >
        {children}
    </ApplicationTableResourceContext.Provider>
);

export default ApplicationTableResourceProvider;
